import * as types from './types';
import { loading } from 'State/actions';

export const getUnclosedDatesReport = data => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.UNCLOSED_DATES_REPORT_FETCHING, true));

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Reports/UnclosedDates',
        data
      );
      dispatch({
        type: types.UNCLOSED_DATES_REPORT_GET_REPORT,
        payload: response.data.Data ? response.data.Data : 'No Data',
      });
    } catch (error) {
      dispatch({
        type: types.UNCLOSED_DATES_REPORT_FETCH_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.UNCLOSED_DATES_REPORT_FETCHING, false));
  };
};

export const clearReport = () => {
  return {
    type: types.UNCLOSED_DATES_REPORT_GET_REPORT,
    payload: null,
  };
};



// WEBPACK FOOTER //
// ./src/pages/uncloseddates/state/uncloseddatesreport/actions.js